<template>
	<b-container fluid class="d-flex flex-column w-100 h-100 px-2">
		<b-row v-for="(section, index) in form.Sections" :key="index" class="p-3 m-0">
			<b-col v-if="section.Visible" class="m-0">
				<b-card no-body class="p-3">
					<b-form-group
						:label="section.Label"
						label-cols="12"
						label-cols-lg="12"
						label-class="font-weight-bold text-dark pt-0 pb-2"
						label-align-sm="left"
						label-size="lg"
						class="m-0" />
					<!-- Construit la liste de champs -->
					<Fields :ParentFormName="form.Name" :Fields.sync="section.Fields" v-bind:ConsultMode="ConsultMode" />
					<!-- Construit les tableaux -->
					<TableDisplaying v-for="table in section.Fields.filter(x => x.Type ===  fieldTypeEnum.Table)" v-bind:key="table.Name" :ObjectType="ObjectType" :TitleTable="table.Label" v-bind:Headers="table.Headers" v-bind:Rows="table.Value" />
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script lang="ts">
	import { Component } from "vue-property-decorator";
	import TableDisplaying from "@/components/commons/TableDisplaying.vue";
	import Fields from "@/components/commons/Fields.vue";
	import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";
	import { BaseObjectForm } from "./BaseObjectForm";

	/** Formulaire générique pour la fiche objet */
	@Component({
		components: {
			Fields,
			TableDisplaying
		}
	})
	export default class Form extends BaseObjectForm {
		/** Pour pouvoir utiliser l'enum FieldTypeEnum dans la section template */
		private fieldTypeEnum = FieldTypeEnum;
	}
</script>

<style scoped>

</style>